import { Injectable, NgZone } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from './api-service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class WorkHistoryService {

    constructor(private api: ApiService){}


    addWorkExpercience(body){
      const url = `/WorkHistory`;
      return this.api.post(url,body)
    }

    updateWorkExpercience(body){
      const url = `/WorkHistory`;
      return this.api.put(url, body);
    }

    getWorkExpercience(id){
      const url = `/WorkHistory/applicant/${id}`;
      return this.api.get(url).pipe(
        map((data: any) => {
          return data;
        })
      );

    }

    deleteWorkExpercience(id){
      const url = `/WorkHistory/${id}`;
      return this.api.delete(url)
    }

    getWorkHistoryItemDetails(id){
      const url = `/WorkHistory/${id}`;
      return this.api.get(url).pipe(
        map((data: any) => {
          return data;
        })
      );
    }

}
